module.exports = __webpack_public_path__ + "img/Case_Study_1_Background.d207495e.jpg";